import { NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import {
  ButtonCloseDirective,
  FormCheckComponent,
  FormCheckInputDirective,
  FormCheckLabelDirective,
  ProgressBarDirective,
  ProgressComponent,
  SidebarComponent,
  SidebarHeaderComponent,
  SidebarToggleDirective,
  TabDirective,
  TabPanelComponent,
  TabsComponent,
  TabsContentComponent,
  TabsListComponent,
  ThemeDirective
} from '@coreui/angular-pro';
import { IconDirective } from '@coreui/icons-angular';

@Component({
    selector: 'app-default-aside',
    templateUrl: './default-aside.component.html',
    styleUrls: ['./default-aside.component.scss'],
    imports: [SidebarComponent, SidebarHeaderComponent, IconDirective, ThemeDirective, ButtonCloseDirective, SidebarToggleDirective, NgTemplateOutlet, FormCheckComponent, FormCheckInputDirective, FormCheckLabelDirective, ProgressBarDirective, ProgressComponent, TabsComponent, TabsListComponent, TabDirective, TabsContentComponent, TabPanelComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultAsideComponent implements AfterViewInit {
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {}

  public messages = Array.from({ length: 5 }, (v, i) => i);

  ngAfterViewInit(): void {
    this.renderer.removeStyle(this.elementRef.nativeElement, 'display');
  }
}
